/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "antd";
import { updateRental } from "../../Redux/Slices/rentals.slice";
import useThreeDotsOptions from "./useThreeDotsOptions";
import { RENTAL_STATUS } from "./constant";

const ListDropdown = ({ detail }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { threeDotsPopoverId } = useSelector((state) => state.rentals);

  const [open, setOpen] = useState(false);

  const options = useThreeDotsOptions().filter((item) => item.hasPermission);

  const getOptions = () => {
    let local = [...options];

    // do not show add battery option if it is used once
    if (detail?.swapBatteries?.length) {
      local = local.filter((item) => item.id !== 1);
    }

    // do not show view battery energy option
    if (+detail.status === RENTAL_STATUS.ONGOING) {
      local = local.filter((item) => item.id !== 2);
    }

    // show view battery energy and view details option
    if (+detail.status === RENTAL_STATUS.COMPLETED) {
      local = local.filter((item) => item.id === 2 || item.id === 4);
    }

    return local;
  };

  const onOptionClick = async (optionId) => {
    dispatch(updateRental({ key: "currentRental", value: detail }));
    setOpen(false);

    switch (optionId) {
      case 1:
        dispatch(updateRental({ key: "batteryEnergyModal", value: true }));
        break;
      case 2:
        dispatch(updateRental({ key: "viewBatteryEnergyModal", value: true }));
        break;
      case 3:
        dispatch(updateRental({ key: "moveToHubStationModal", value: true }));
        break;
      case 4:
        navigate(`/rentals/${detail.id}`);
        break;
      default:
        break;
    }
  };

  const handleOpenChange = (state) => {
    setOpen(state);

    dispatch(
      updateRental({
        key: "threeDotsPopoverId",
        value: detail.id,
      }),
    );
  };

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={open && threeDotsPopoverId === detail.id}
      arrow={false}
      onOpenChange={(state) => handleOpenChange(state)}
      content={
        <div
          className="rounded-md bg-background-white py-1"
          style={{
            width: "200px",
            boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.10)",
          }}
        >
          {getOptions().map((option) => (
            <button
              type="button"
              className="w-full flex items-center gap-x-3 px-3 py-2 group hover:bg-background"
              key={option.id}
              onClick={() => onOptionClick(option.id)}
            >
              {option.icon}

              <p className="font-aileron text-xs font-semibold capitalize whitespace-nowrap text-dark-gray group-hover:text-black">
                {option.value}
              </p>
            </button>
          ))}
        </div>
      }
    >
      <div className="cursor-pointer">
        <img src="/assets/icons/trips/more.svg" alt="dropdown" />
      </div>
    </Popover>
  );
};

export default ListDropdown;
